import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {Editor} from 'primeng/editor';
import {NgForm} from '@angular/forms';
import {ValidationService} from '../../services/validation.service';

@Component({
  selector: 'si-rich-text',
  templateUrl: './rich-text.component.html',
  styleUrls: ['./rich-text.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RichTextComponent implements AfterViewInit {
  @Input() text: string;
  @Input() placeholder: string;
  @Input() styleClass: string;
  @Input() id: string;
  @Input() name: string;
  @Input() disabled: boolean;
  @Input() rule: string;
  @Input() validationExternalErrorText: string;
  @Input() model: any;
  @Input() resize: boolean;
  @Input() tooltipText: string;
  @Input() tooltipPosition: string;
  @Input() tooltipIcon: string;
  @Input() tooltipStyleClass: string;
  @Input() tooltipEscape = true;
  @Input() forceShowTooltipIcon: boolean;
  @Input() hideLabel = false;
  @Output() modelChange = new EventEmitter<string>();
  @Output() tooltipIconClick = new EventEmitter<any>();
  @ViewChild('textEditor', { static: true }) textEditor: Editor;
  showRuleErrorOutsideIcon: boolean;
  validationErrorText: string;

  constructor(
    private el: ElementRef,
    private validationService: ValidationService
  ) {
    this.setLogic();
  }

  ngAfterViewInit() {
    const parentWithClass = this.el.nativeElement.closest('.readmode');

    if (parentWithClass) {
      this.disabled = true;
    }
  }

  setLogic(): void {
    this.showRuleErrorOutsideIcon = this.validationService.getShowRuleErrorOutsideIcon();
  }

  onChangeModel(model: any): void {
    // Back webservices do not accept empty model.
    if (model === '') {
      model = undefined;
    }

    this.modelChange.emit(model.htmlValue);
  }

  onClickTooltipIcon(event: any): void {
    this.tooltipIconClick.emit(event);
  }
}
